module.exports = __webpack_public_path__ + "static/media/graph-apollo.01058bac.png";